import { useEffect, useState } from 'react';
import { Link,  NavLink, useLocation, useNavigate } from 'react-router-dom';
import '../css/Sidebar.css';
import LogoSenaGestor from '../image/LogoSenaGestor.png';
import DropdownMenu from './DropdownMenu';

const Sidebar = ({ sidebarRef, isOpen, onCloseSidebar }) => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();

  const toggleDropdown = (dropdownId) => {
    setActiveDropdown(activeDropdown === dropdownId ? null : dropdownId);
  };

  // Cierra el sidebar al cambiar de ruta (solo en modo móvil)
  useEffect(() => {
    let timeout;
    const handleOutsideClick = (e) => {
      if (
        isOpen &&
        sidebarRef?.current &&
        !sidebarRef.current.contains(e.target) &&
        window.innerWidth <= 767.98
      ) {
        onCloseSidebar?.();
      }
    };

    if (isOpen) {
      // Espera un pequeño tiempo antes de activar el listener
      timeout = setTimeout(() => {
        document.addEventListener('mousedown', handleOutsideClick);
      }, 100);
    }

    return () => {
      clearTimeout(timeout);
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isOpen, onCloseSidebar, sidebarRef]);


  // Cierra el sidebar si se hace clic fuera de él (solo en móviles)
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        isOpen &&
        sidebarRef?.current &&
        !sidebarRef.current.contains(e.target) &&
        window.innerWidth <= 767.98
      ) {
        onCloseSidebar?.();
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isOpen, onCloseSidebar, sidebarRef]);

  const handleLinkClick = () => {
    if (window.innerWidth <= 767.98) {
      onCloseSidebar?.();
    }
  };

  useEffect(() => {
    if (window.innerWidth <= 767.98 && isOpen) {
      onCloseSidebar?.();
    }
    // eslint-disable-next-line
  }, [location]);

 const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/", { replace: true });
  };


  return (
    <nav
      id="sidebarMenu"
      ref={sidebarRef}
      className={`sidebar-custom d-md-block ${isOpen ? 'show-mobile' : 'd-none d-md-block'}`}
    >

      <div className="position-sticky pt-4 h-100 d-flex flex-column">
        <div className="sidebar-header text-center mb-4">
          <img src={LogoSenaGestor} alt="Logo" style={{ height: '200px' }} />
        </div>

        <div className="text-center d-md-none mb-3">
          <button className="btn btn-outline-light" onClick={onCloseSidebar}>
            Cerrar menú
          </button>
        </div>

        <ul className="nav flex-column mb-auto">
          <li className="nav-item">
            <Link to="/inicio" className="nav-link text-white d-flex align-items-center">
              <i className="fas fa-home me-2"></i>
              <span>Inicio</span>
            </Link>
          </li>

          <NavLink
            to="/instructor/"
            onClick={handleLinkClick}
            className={({ isActive }) =>
              `nav-link d-flex align-items-center gap-2 px-3 py-2 rounded-3 text-white ${isActive ? "active fw-semibold" : ""
              }`
            }
            title="Instructor"
          >
            <i className="fa-solid fa-chalkboard-user"></i>
            <span>Instructor</span>
          </NavLink>

          <NavLink
            to="/aprendiz/"
            onClick={handleLinkClick}
            className={({ isActive }) =>
              `nav-link d-flex align-items-center gap-2 px-3 py-2 rounded-3 text-white ${isActive ? "active fw-semibold" : ""
              }`
            }
            title="Aprendices"
          >
            <i className="fa-solid fa-graduation-cap"></i>
            <span>Aprendices</span>
          </NavLink>

          <DropdownMenu
            id="institucionalDropdown"
            iconClass="fa-solid fa-building-columns"
            label="Institucional"
            submenuId="submenuInstitucional"
            isOpen={activeDropdown === 'institucionalDropdown'}
            toggleDropdown={() => toggleDropdown('institucionalDropdown')}
            links={[
              { to: '/institucional/regional/', label: 'Regional', iconClass: 'fas fa-user' },
              { to: '/institucional/centro/', label: 'Centro', iconClass: 'fas fa-shield-alt' },
              { to: '/institucional/programas/', label: 'Programa', iconClass: 'fas fa-bell' },
              { to: '/institucional/grupos/', label: 'Grupos', iconClass: 'fas fa-bell' },
            ]}
            onLinkClick={handleLinkClick}
          />

          <DropdownMenu
            id="enteConformadorDropdown"
            iconClass="fa-solid fa-school"
            label="Ente Conformador"
            submenuId="submenuEnteConformador"
            isOpen={activeDropdown === 'enteConformadorDropdown'}
            toggleDropdown={() => toggleDropdown('enteConformadorDropdown')}
            links={[
              { to: '/enteconformador/ente/', label: 'Listar Entes', iconClass: 'fas fa-shield-alt' },
              { to: '/enteconformador/jefes/', label: 'Listar Jefes', iconClass: 'fas fa-bell' },
            ]}
            onLinkClick={handleLinkClick}
          />

          <DropdownMenu
            id="matriculaDropdown"
            iconClass="fa-solid fa-person-chalkboard"
            label="Matricula"
            submenuId="submenuMatricula"
            isOpen={activeDropdown === 'matriculaDropdown'}
            toggleDropdown={() => toggleDropdown('matriculaDropdown')}
            links={[
              { to: '/matricula/listarmatriculas/', label: 'Listar Matriculas', iconClass: 'fas fa-user' },
              { to: '/tarjeta/listartarjetaaprendiz/', label: 'Tarjeta UID', iconClass: 'fas fa-bell' },
              { to: '/etapaproductiva/listareproductiva/', label: 'Etapa Productiva', iconClass: 'fas fa-bell' },
              { to: '/etapaproductiva/seguimientopractica/', label: 'Seguimiento Práctica', iconClass: 'fas fa-bell' },
            ]}
            onLinkClick={handleLinkClick}
          />

          <DropdownMenu
            id="reportesDropdown"
            iconClass="fas fa-chart-line"
            label="Reportes"
            submenuId="submenuReportes"
            isOpen={activeDropdown === 'reportesDropdown'}
            toggleDropdown={() => toggleDropdown('reportesDropdown')}
            links={[
              { to: '/reportes/diarios', label: 'Diarios', iconClass: 'fas fa-calendar-day' },
              { to: '/reportes/mensuales', label: 'Mensuales', iconClass: 'fas fa-calendar-alt' },
            ]}
            onLinkClick={handleLinkClick}
          />

          <DropdownMenu
            id="configuracionDropdown"
            iconClass="fas fa-cog"
            label="Configuraciones"
            submenuId="submenuConfiguraciones"
            isOpen={activeDropdown === 'configuracionDropdown'}
            toggleDropdown={() => toggleDropdown('configuracionDropdown')}
            links={[
              { to: '/configuraciones/perfil', label: 'Perfil', iconClass: 'fas fa-user' },
              { to: '/configuraciones/seguridad', label: 'Seguridad', iconClass: 'fas fa-shield-alt' },
              { to: '/configuraciones/notificaciones', label: 'Notificaciones', iconClass: 'fas fa-bell' },
              { to: '/configuraciones/asignarmodulos', label: 'asignar-modulos', iconClass: 'fas fa-bell' },
            ]}
            onLinkClick={handleLinkClick}
          />

          <li className="nav-item">
            <Link className="nav-link text-white d-flex align-items-center" to="/ayuda">
              <i className="fa-solid fa-handshake-angle me-2"></i>
              <span>Ayuda</span>
            </Link>
          </li>
        </ul>

        <div className="mt-auto d-flex justify-content-center mb-3">
          <button
      className="btn btn-outline-light"
      type="button"
      onClick={handleLogout}
    >
      Cerrar sesión
    </button>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;
